export enum DialogEnum {
    Confirm,
    Cancel
  }
